import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'
import storage from 'libs/storage'
import wechat from 'libs/wechat'
import api from '@/api'
import store from '@/store'
import {Dialog,Toast} from 'vant'
import utils from 'libs/utils'
Vue.use(Router)
const router = new Router({
    routes,
    mode: 'history'
})
const LOGIN_PAGE_NAME = 'login';
const homeName = 'index';
const overName = 'pause';
var checkLogin = (to, token, next,from) => {
    // if(to.name === overName) {
    //     next();   
    // } else {
    //     next({
    //         name: overName // 跳转到homeName页
    //     })
    // }
    if (to.meta.requiresAuth === true) {
        if (!token && to.name !== LOGIN_PAGE_NAME) {
            // utils.loginConfirm(to).then((res)=>{
            //     if(res){
            //       store.dispatch('getUserInfo');
            //       router.replace({name:to.name,params:to.params,query:{}})
            //     }
            //   });

            next(`/login`)

        } else {
            // window.history.replaceState(null, null, window.location.href);
            next();
        }

    } else {
        if (token && to.name === LOGIN_PAGE_NAME) {         
            // 已登录且要跳转的页面是登录页
            next({
                name: homeName // 跳转到homeName页
            })
        } else {           
            next();           
        }

    }
}
router.beforeEach((to, from, next) => {
    if (to.meta.showloading) {
        Toast.loading({
            duration: 0, // 持续展示 toast
            overlay:false,
            forbidClick:true
        });
    }
    
    //appInfo 原始链接
    let token = window.localStorage.getItem('token');
    //记录位置
    if(from.meta.keepAlive){
        const scrollX = window.pageXOffset || window.document.documentElement.scrollLeft || window.document.body.scrollLeft
        const scrollY = window.pageYOffset || window.document.documentElement.scrollTop || window.document.body.scrollTop
        storage.set(from.name+'scroll',{scrollX, scrollY})
    }


    if(to.meta.bgcolor){
        store.commit('setBgColor',to.meta.bgcolor)
    }else{
        store.commit('setBgColor','#fff')
    }

    checkLogin(to, token, next,from);
})

router.afterEach((to) => {
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    if (to.meta.keepAlive) {
        storage.get(to.name+'scroll').then((res)=>{
            setTimeout(()=>{
                window.scrollTo(res.scrollX, res.scrollY)
            },1)
        })

    } else {
        window.scrollTo(0, 0)
    }
    //ios wechat sdk
    if (window.__wxjs_is_wkwebview) {  // IOS
        if (window.entryUrl == '' || window.entryUrl == undefined) {
            var url = `${window.location.origin}${to.fullPath}`
            window.entryUrl = url    // 将后面的参数去除
        }
    }
    // if (to.meta.share) share();
    if (to.meta.showloading){
        setTimeout(() => {
            Toast.clear()
        },10e2)
    }

})

export default router
